import React from 'react';
import FundingPanel from '../../components/funding/FundingPanel';
import FundingSectionPage from '../../components/funding/FundingSectionPage';

const createStagePage = (title, subtitle, activeStage, body) => {
  const Page = () => (
    <FundingSectionPage title={title} subtitle={subtitle} activeStage={activeStage}>
      <FundingPanel>
        <p className="text-sm leading-6 text-[var(--fg-muted)]">{body}</p>
      </FundingPanel>
    </FundingSectionPage>
  );
  Page.displayName = `Funding${activeStage}Page`;
  return Page;
};

export const FundingProfilesPage = createStagePage(
  'Funding Profiles',
  'Entity, revenue, use-of-funds, and advisor notes for each funding candidate.',
  'intake',
  'Funding profiles will connect to FundElite client accounts and document storage without mixing credit repair workflows.',
);

export { default as FundingReadinessPage } from './FundingReadinessPage';
export { default as FundingDocumentsPage } from './FundingDocumentsPage';
export { default as FundingBankMatchPage } from './FundingBankMatchPage';
export { default as FundingSequencePage } from './FundingSequencePage';
export { default as FundingSubmissionsPage } from './FundingSubmissionsPage';
export { default as FundingPipelinePage } from './FundingPipelinePage';
export { default as FundingCommissionsPage } from './FundingCommissionsPage';
export { default as FundingReportsPage } from './FundingReportsPage';
export { default as FundingLendersPage } from './FundingLendersPage';
export { default as FundingLenderDetailPage } from './FundingLenderDetailPage';
export { default as FundingAIAdvisorPage } from './FundingAIAdvisorPage';

export const FundingSettingsPage = createStagePage(
  'FundGenius HQ Settings',
  'Workspace defaults, intake forms, lender preferences, and advisor permissions.',
  'intake',
  'Settings reuse FundElite roles, billing, and agency configuration without touching dispute modules.',
);
